var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"id":"pdf-js-viewer","title":"webviewer","height":"100%","width":"100%","frameborder":"0","src":_vm.path + _vm.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }